<template>
  <div>
    <transition name="fade">
      <div class="out" v-if="showModal">
        <div class="common-small-dialog-wrap">
          <div class="common-small-dialog-content">
            <div class="dialog-center-bg"></div>
            <div class="dialog-close-btn" @click="close()"></div>
            <div class="dialog-header">
              <div>个人资料</div>
              <!-- <div class="user-avatar">
                <img :src="userDetails.avatar || defaultAvatar" alt="" id="userAvatar" mode="aspectFit" />
              </div> -->
            </div>
            <div class="dialog-content">
              <div class="update-content">
                <!-- <div class="nickname">{{ userDetails.nickName }}</div> -->
                <div class="tab-wrap">
                  <div @click="changeTab(0)" :class="[type == 0 ? 'sel' : '']" class="tab-item">
                    <span>修改昵称</span>
                  </div>
                  <div @click="changeTab(1)" :class="[type == 1 ? 'sel' : '']" class="tab-item">
                    <span>修改头像</span>
                  </div>
                </div>
                <div class="opt-content">
                  <div v-if="type == 0" class="nickname-update-box">
                    <div class="input-box">
                      <input type="text" v-model="userDetails.nickName" placeholder="请输入您的新昵称"
                        placeholder-style="color: #CFCFCF" />
                    </div>
                  </div>
                  <div v-if="type == 1" class="avatar-list-wrap">
                    <div @click="changeAvatar(item.avatar)" :class="[selectAvatar == index ? 'sel' : '']"
                      class="avatar-item" v-for="(item, index) in avatar" :key="index">
                      <!-- <img :src="item.avatar | fullPath" alt="" /> -->
                      <img :src="`${$getFullPath(item.avatar)}`" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="buy-back-dialog">
                <div class="flex-center btn-group">
                  <!-- <div
                    class="cancel-btn"
                    @click="close()"
                    style="font-size: 24rpx"
                  >
                    取 消
                  </div> -->
                  <div class="sure-btn" @click="confirm()" style="font-size: 24rpx">
                    确 认
                  </div>
                </div>
              </div>
            </div>
            <div class="dialog-footer"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { getavatar } from "@/api/index";
export default {
  name: "modalDefault",
  data() {
    return {
      type: 0,
      avatar: [],
      selectAvatar: -1,
      newAvatar: "",
      nickname: "",
      user: {},
      selectAvatarId: "",
      defaultAvatar: require("../../assets/images/default-header.png"),
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm", this.userDetails, this.type);
    },
    changeTab(type) {
      this.type = type;
    },
    changeAvatar(avatar) {
      this.userDetails.avatar = avatar
    },
    // 获取头像
    getAvatar() {
      getavatar().then((res) => {
        this.avatar = res.data.data;
      });
    },
    init() {
      this.getAvatar()
    },
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    userDetails: {
      type: Object,
      default: () => { },
    }
  },
  watch: {
    showModal(newValue, oldValue) {
      if (newValue) {
        this.$soundPlay("dialogOpen");
        this.init();
      } else {
        this.$soundPlay("dialogClose");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/style/modal.scss";

.out {
  width: 100%;;
  // max-width: 525px;
  height: 100vh;
  transform: translateX(-50%);
  position: fixed;
  left: 50%;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;

  @media (max-width: 550px) {
    width: 100%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}

.common-small-dialog-wrap {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.buy-back-dialog .buy-box img {
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
}

.buy-back-dialog .cancel-btn {
  margin-right: 5.33 * 4.2px;
}

.buy-back-dialog,
.password-dialog,
.link-dialog,
.tips-dialog {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.buy-back-dialog .sure-btn,
.password-dialog .sure-btn,
.link-dialog .sure-btn,
.tips-dialog .sure-btn,
.buy-back-dialog .cancel-btn,
.password-dialog .cancel-btn,
.link-dialog .cancel-btn,
.tips-dialog .cancel-btn {
  width: 28.67 * 4.2px;
  height: 8 * 4.2px;
  background-size: 28.67 * 4.2px 8 * 4.2px;
  text-align: center;
  line-height: 8 * 4.2px;
}

.buy-back-dialog .sure-btn,
.password-dialog .sure-btn,
.link-dialog .sure-btn,
.tips-dialog .sure-btn {
  margin-top: 4 * 4.2px;
  background: url("../../assets/image3/home/btnBack.png") no-repeat 0 0;
  background-size: 100% 100%;

  width: 32.67 * 4.2px;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
}

.buy-back-dialog .cancel-btn,
.password-dialog .cancel-btn,
.link-dialog .cancel-btn,
.tips-dialog .cancel-btn {
  margin-top: 4 * 4.2px;
  background: url("../../assets/images/del_confirm_btn.png") no-repeat 0 0;
  background-size: contain;

  width: 26.67 * 4.2px;
  height: 10 * 4.2px;
  line-height: 10 * 4.2px;
}

.btn-group {
  position: absolute;
  bottom: -35px;
  width: 100%;
}

//  .user-avatar {
//   width: 13.6*4.2px;
//   height: 13.6*4.2px;
// }

.user-avatar {
  width: 39.33 * 4.2px;
  height: 23.6 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  margin-top: -8 * 4.2px;
}

.user-avatar:after {
  content: "";
  display: block;
  width: 38.13 * 4.2px;
  height: 16.8 * 4.2px;
  background: url("../../assets/images/avatar_outer_box2.png") no-repeat 0 0;
  background-size: 38.13 * 4.2px 16.8 * 4.2px;
  position: absolute;
  left: 0.53 * 4.2px;
  top: 1.6 * 4.2px;
}

.user-avatar img {
  width: 17.07 * 4.2px;
  height: 14.67 * 4.2px;
  position: relative;
  -o-object-fit: cover;
  object-fit: cover;
  z-index: 1;
  -webkit-clip-path: polygon(73% 0,
      99% 51%,
      74% 100%,
      26% 100%,
      1% 51%,
      28% 0%);
  clip-path: polygon(73% 0, 99% 51%, 74% 100%, 26% 100%, 1% 51%, 28% 0%);
}

.update-content {
  width: 100%;
  overflow: hidden;
  padding-top: 2.67 * 4.2px;
}

.update-content .nickname {
  width: 100%;
  height: 8 * 4.2px;
  line-height: 8 * 4.2px;
  text-align: center;
  font-size: 4.4 * 4.2px;
  color: #d4d4ff;
}

.update-content .tab-wrap {
  width: 100%;
  height: 11.2 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  // -webkit-justify-content: center;
  -ms-flex-pack: center;
  // justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 1.87 * 4.2px 4.76 * 4.2px 0;

  @media only screen and (max-width: 430px) {
    padding: 1.87vw 4.76vw 0;
  }
}

.update-content .tab-wrap .tab-item {
  width: 21.07 * 4.2px;
  height: 9.33 * 4.2px;
  background: url("../../assets/image3/share/notSelectedBack.png") no-repeat 0 0;
  background-size: 21.07 * 4.2px 9.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #ffffff;
  font-size: 3.33 * 4.2px;
  // margin: 0 4.8 * 4.2px;
}

.update-content .tab-wrap .tab-item.sel {
  background: url("../../assets/image3/share/selectBack.png") no-repeat 0 0;
  background-size: 21.07 * 4.2px 9.33 * 4.2px;
  color: #ffffff;
}

.update-content .opt-content {
  width: 100%;
  min-height: 38.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.update-content .opt-content .nickname-update-box {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 4.76 * 4.2px;

  @media only screen and (max-width: 430px) {
    padding-top: 4.76vw;
  }
}

.update-content .opt-content .nickname-update-box .input-box {
  width: 19rem;
  height: 3rem;
  background: #302077;
  margin: 0 auto;
  border-radius: 5px;
}

.update-content .opt-content .nickname-update-box .input-box input {
  width: 100%;
  height: 3rem;
  // text-align: center;
  background: transparent;
  font-size: 3.33 * 4.2px;
  padding-left: 10px;
}

.update-content .opt-content .nickname-update-box .input-box input::-webkit-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.update-content .opt-content .nickname-update-box .input-box input::-moz-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.update-content .opt-content .nickname-update-box .input-box input::-ms-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.update-content .opt-content .nickname-update-box .input-box input::placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
}

.update-content .opt-content .avatar-list-wrap {
  width: 88%;
  height: auto;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // padding-left: 11.33 * 4.2px;
  // padding-top: 4 * 4.2px;
  // padding-bottom: 2.67 * 4.2px;
  // background: url('../../assets/images/avatar-list-wrap.png') no-repeat 8.93 * 4.2px 5.33 * 4.2px;
  // background-size: 61.33 * 4.2px 34.27 * 4.2px;
  background-color: #302077;
  border-radius: 5px;
  margin: 10px auto 0;
  padding: 0.8rem;
  // padding: 0 0 2.67 * 4.2px 2.67 * 4.2px;

}

.update-content .opt-content .avatar-list-wrap .avatar-item {
  width: 12 * 4.2px;
  height: 12 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  // margin-right: 2.67 * 4.2px;
  // margin-top: 4.53 * 4.2px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  background: url('../../assets/image3/user/headBack.png') no-repeat 0 0;
  background-size: 12 * 4.2px 12 * 4.2px;
  margin-right: 1rem;
}

// .update-content .opt-content .avatar-list-wrap .avatar-item:after {
//   content: "";
//   display: block;
//   width: 12 * 4.2px;
//   height: 12 * 4.2px;
//   background: url('../../assets/image3/user/headBack.png') no-repeat 0 0;
//   background-size: 12 * 4.2px 12 * 4.2px;
//   position: absolute;
//   left: 0;
//   top: 0;
//   z-index: 1;
// }

// .update-content .opt-content .avatar-list-wrap .avatar-item.sel:after {
//   content: "";
//   display: block;
//   width: 12 * 4.2px;
//   height: 12 * 4.2px;
//   background: url('../../assets/image3/user/headBack.png') no-repeat 0 0;
//   background-size: 12 * 4.2px 12 * 4.2px;
//   position: absolute;
//   left: 0;
//   top: 0;
//   z-index: 1;
// }

.update-content .opt-content .avatar-list-wrap .avatar-item img {
  width: 9.47 * 4.2px;
  height: 9.47 * 4.2px;
  -webkit-border-radius: 5.73 * 4.2px;
  border-radius: 5.73 * 4.2px;
}

.update-content .opt-content .avatar-list-wrap .add-btn {
  width: 12 * 4.2px;
  height: 12 * 4.2px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAAKmYvLWwzm9Sz3hW2c6YvY6i8qSf3Kai0K+au5eYv5yx+eaVuzImyqqq1JyZvpCl97iSpFpYx0Ex9NSdzI6b0ams1pKn99Saq5aV*4.2px1d3qygviceyp6Jy9+Ru7t9y4iGyuOUwZmm4j4x2O+u2ceWo7iivLSLqI2Vymxr3Jih17eXsv281uKXsZuv+ayNrUUy+IRg7cmOscSEwueYxqOo2ZKYyIGI1I2c1rKbu6qo0aiWtJOJyZir6bOfvjwt4n1W44qZ2J+z+iMrfpGg+bKPqV9e3IKR5b6OrpSp88CPpcmTrCsg2bWEt25R32Jj6aGXxn+J4q+Kpmpu7oqc5qiNrPWq2Hpg1WtZ4y8i+YeW8fq228aL3isf99aWvOKUtysmuOyezKSavo+c05Om4WlV1I6h4oye56qCs/Wpyt6i30w59DYm+/Sp2OWVvqiRrTkt0KecvyQcyUY34iEdv+ycvrKOppp5v/yw19KSr9uUs/Oq2ioh1eCUv7yFu5uk1eiWxJmp56eYvcuYu++y0beSpzEm5O2gyWBf1KSUtqKUvSQphi0i5tGct+Cnw+SrvCcnnOa*4.2pxe+fyiYrkB0laSsptBAaRjEu0zMu35pq5KSo1nuC+o2D0IaT2AwXPQ0YQMer9g0YQsyr8vCr2BAcRc+r8NKr7sqr9PKr1uqr3Dcxvuer3hskaRIcUeOr4SAjjyIcrpV+uRYZeSMdsxYfSCMgqeyr2x8Zn4V4tiMmd9ar6yIhmRgkViAbpyYguBsfdu6r2TowyBkjYiMkoToyxLqGrx0lb2Vk0BEbSp2y+Sckrp54pfSr1Twxzh8Wuh8qeCslpsWr9yIsbTUwtaKDuSstV42U3ot7umZUxyQbvxgXra6RqryovCgiwa1/qbKDrrOmwJqv8+yZtycviVhc1Sw1oZeZ3X5lkyYslzYmy0I+ai82q7aMw/6y1JN3qtyo4CoyndOg166HvGtdkF9Uhb2a11JJdrySysiY0JaQ1C01kLSLqYpvn8qk5JCc7URCyrLXCqwAAADydFJOUwAp/PzjCicDBzTS8fv4wPdo/PzQD830uP2l3/r+78r3/H+U/bn8+MKe/v38+v2badvvxPw3kPf89H5x/v3+yd/pnMv+/s79/r7t6Ore+vLmHfmI9m+60Pvlu/3i99DD8f2IedX+6fe//vz96t4+z/HxxO319/zt9vjt7o39/vnMK8xvvOPq8/3ywELpx+bm/es90bLuyuefhveL8/T0///////////////////////////////////////////////////////////////////////////////////////////////////////////////+wj4AHgAAB7BJREFUWMOl2XtUk3Ucx/EJ4aAwI8jITckWmplBpWUiTSMza6FohZQUmpqEFSFoFyy7eUFLTe1+mBNRuW40JhlsNZiXZkNEUZfNSMoZGYRXMu30/f1+z/Ns043f79k+/3jEc17nfX48zzO3SSQ+FtX7ujtdu8VjI2FfoI38YnTBZKlE3EJBflDYO2jPk72Ndi2/kaPDQsXJ0t7X3TjxGmGJiYmzbndbP9euHd1LKla+5ocfHuL2H+ygsOMHj/O7HdtiuqWTifzlVLSheLs8Rn42NOV4vyDUHSqy+empWQqb2WwpRduP9ud+bqWlFovFbFPMH3qwX1AQezfX/PRUhbyxUa/TGY01njPCdDq9yS7PVzz8TxCy2br55odtdrvdlGGyWq2GBvcZDAb4WUaGw+GQy3k7TMp01RHZbNJZ/4T9Dvv7BOxv+JMM/Qj9k9VqctiYu4Vmi76xKal5J1n5ZeN+vPO7Wr3DtouzpYzNFp2xqa1Oo9ao3abx/JtaXfFdrc5uRnYr2CHUOwXJpTpdw946TSFl2DaZd40JCpK9+m5P3ah54q+/IrmmNqlOXVjIYhtMlsNjWluRHdpjM8i/lRqMtQzNaBrcLdjSnptBrgFZXcg01G3Ugy1rlS330c01TyDNFYwy6TZgW5aw3Gt3qEuu0TI3c91ao770cFVCQsLyuCu73ZprGvZWaApFjO8G+5XlcZe/NIT2fuKFiYmJ+DTENfPdBug+BPaTcZ5nInXJqFmkzF+D+EzAdu+WBtQsdMM1eCjhiEc3Oo05ATS73ztVR464dUuxPCvlt1KdsdavZt62Cjbpxs2zZkGzrqYhqcJPmet2mPnuUCn8fwPLKdwTyW+Z2PCMBTtiAXRHSQqQPCdlUh+9saEtENndPgJ2geSJcaPmgKxshCd/3abCwkBtk1wRvBDZUyTjbhh1MGVSZI6+KcBmwc5XzEZnMkQy7vlRE6ZGquT723pudu7g5+zZbnDkz0+dG7FgPKpG0dYL9T03H/0Rb+*4.2pxrXso3Yb8JckHIj4YwtG5bbRzPkpcGg22Vu5OKzO20551R4lbVFS0h/Ic/FqucKPnZ2zfxEIDXPQ9lbYrgnn6vknZTHQRlhloW/DcWJ62WZno72HbtlFpk+3w3NhHCb3MbN1JpYuwu62khJF+RHIbpg10GsElJSVlZSLoe+9bZmkqp9NILitjoPXmw6diHyP09ZYmejVJLqvsdLLQ0S66mUbvQXBlZWXnqXZRdKl3+uI*4.2pxo52lXHyuZaWMx0HuDn9pXegexsuZe6UQe46cK66/eLZb/lV+aBPRn/4HgMNlwZ3GJVdHeda3GXvtI6JRs2C3NnV0d7S3gHyZn4+6GBCX33vzT5pVzPQnd0X2+vOVV3i4OLi4s3FPulVVJocNGnudra3gEzU4uKNGzcW+6TPr/qIQmOZ0J3nnXBpHLiE4Y38vNJWTD9LoYWD7jx/GuRTlzh4CzdfdDcbjeWTIJ8+iZI5eAPeIe8XX3B3JtA3Xd0X0V5v9B2CfOoMyOeJ7IJ90bbU7sz3b8X0Mov3J59zD15Hh7O9rsV5lpPPfuPaaR901x0cPdtCf6ie4eUt39Afqi66v4X+UtDByxvE0dnWvTS6CmgsM9CK1BfF0RCNf38M9F0v3vEMRysz6DRc0FvYaIc7HclCw3Gg620fnZ4v0GP6R+YksdL76LTcg15Jp8nvkInOch3ItPi0FRo2eh+V3q3Nd9FjgF5bTaW5aAq9u9y4xI1OjU/7dN0mFnofhVbvLq/NnZf1eRlHQ3Zk2nrKf91PH+J3pqfmeq19Sfxd04sQPfOmvrK+X02LX7m6PsA3Sai5XmuCk56+7a/XnnpTUjDzVZlMBt2qE/WBvk0CWQ9X3vQiJA+STA4Du1U2YFpkjrZeE5BcUa7VIflHJL+0WCIN6YXs1gH9lbnagN7s7kaygpej0Lv0UNT9M7L1AXSrK5rbDHbF2Olbicx9aNFr5gODkZ3dqK3T+NvcfMFg/yOZbxY+EAnj7D46bb3a7+bGP4Jx8wyXzHf/PGB2H5PWnzfq6urmC0YkZ/6V+dSMER4froaE3Y+7Z/vVjZqRHLM0M/Njj2ZyJvdz3XbR3ficBXnEFR8Ik+7BfnSDjM85ZtHSpVc2X9bdJuaeh+uZNOfl5Xlrxl9NCd0mMfc83CmkOS/v5Rlronx8FMzb2Q4taze6B+F6Do4JB3nQCJ8fvOPuwcMG9FflsnbDE0kH78ljFh0LBznK9+fuqHvYMLCVOWzd5LlxVUw4ktf09GWBFK6T8diOVK1m6AZZL1eO5ZspX3EQeyG8yK9fV02VT+Sq4seS5hEhtC9muO6F8Jr26dpPPqn2vU1161ar0gU5iuHrpLAp4yMi/l0IL/OffbZ2xYqkpO1elpTUtmL1+jROHsjQTLp5Oz0tLW2lKidXr//JY/rG3NwcVXp6+jxeXhzC9tUdbydnzZsXHwlTKlXZfVzLVim*4.2pxMKy8G+QtdndTk1Ovsr7xqIlJ39O5MUh7F+TcvYvc2GPC3sL7x73LQoX1czbCyJi+UXHRnMbHj2cX/jwY8eOPSeuGd/zBVOGLHiU7DG818neIHuO28BBa6IkIr/t7hU3ZQjeI7C73fcs2kBuM+IW+3pu/A+BFhCKl64FWgAAAABJRU5ErkJggg==) no-repeat 0 0;
  background-size: 12 * 4.2px 12 * 4.2px;
  float: left;
  margin-right: 2.67 * 4.2px;
  margin-top: 4.53 * 4.2px;
}

/deep/.common-small-dialog-content {
  height: 340px;
}
</style>